import type { Platform, SeriesFormat, SeriesStatus, Side, UserRole } from '@vmt/shared';

const dateTime = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium', timeStyle: 'short' });
const date = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium' });

export const formatDateTime = (iso: string | null | undefined) =>
  iso ? dateTime.format(new Date(iso)) : '–';
export const formatDate = (iso: string | null | undefined) =>
  iso ? date.format(new Date(iso)) : '–';

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '–';
  const diff = Date.now() - new Date(iso).getTime();
  const rtf = new Intl.RelativeTimeFormat('de-DE', { numeric: 'auto' });
  const minutes = Math.round(diff / 60_000);
  if (Math.abs(minutes) < 60) return rtf.format(-minutes, 'minute');
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return rtf.format(-hours, 'hour');
  const days = Math.round(hours / 24);
  if (Math.abs(days) < 30) return rtf.format(-days, 'day');
  return formatDate(iso);
}

export const FORMAT_LABEL: Record<SeriesFormat, string> = {
  bo1: 'Best of 1',
  bo3: 'Best of 3',
  bo5: 'Best of 5',
};

export const STATUS_LABEL: Record<SeriesStatus, string> = {
  draft: 'Entwurf',
  veto: 'Veto',
  live: 'Live',
  finished: 'Beendet',
  cancelled: 'Abgebrochen',
};

export const ROLE_LABEL: Record<UserRole, string> = {
  admin: 'Admin',
  organizer: 'Organizer',
  player: 'Spieler',
};

export const PLATFORM_LABEL: Record<Platform, string> = { pc: 'PC', console: 'Konsole' };

export const SIDE_LABEL: Record<Side, string> = { attack: 'Angriff', defense: 'Verteidigung' };

export const percent = (value: number | null | undefined) =>
  value == null ? '–' : `${value.toLocaleString('de-DE')} %`;
